import { render, staticRenderFns } from "./PatternDetail.vue?vue&type=template&id=3a8d67ec&scoped=true"
import script from "./PatternDetail.vue?vue&type=script&lang=js"
export * from "./PatternDetail.vue?vue&type=script&lang=js"
import style0 from "./PatternDetail.vue?vue&type=style&index=0&id=3a8d67ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d67ec",
  null
  
)

export default component.exports